import React from "react";
import AnalyticsEvent from "../shared/AnalyticsEvent";

const Newsletter = () => {
  return (
    <div className="row">
      <div
        className="col-lg-6 order-lg-last"
        data-aos="fade-left"
        data-aos-duration="1200"
      >
        <div className="text-wrapper pl-3">
          <div className="title-style-three mb-35 md-mb-20">
            <h6>EduZ Tuition Newsletter Q3 2025</h6>
            <h2> 
              <span>
              Get Spirited Away Studying!{" "}
                <img src="images/shape/line-shape-7.svg" alt="shape" />
              </span>
              
            </h2>
          </div>
          {/*  /.title-style-two */}
          <p>
          Get spirited away into your most productive quarter yet with our magical Q3 newsletter! Master Chinese and Economics with expert study techniques while staying organized with our exclusive digital calendar and self-care tools. Discover how to learn while scrolling TikTok with curated educational accounts, explore fascinating Singapore education facts, and dive into cultural celebrations like the Hungry Ghost Festival and National Day. Plus, get an exclusive interview with 余老师 and learn about our personalized student progress reports. Whether you're boosting grades or finding study-life balance, this newsletter is your perfect companion!
          </p>
          <p className="mt-30">
          <a href="/docs/newsletter/EduZTuition-Q3-2025-Newsletter.pdf"
                target="_blank"
                rel="noreferrer"
                className="theme-btn-five"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="200"
                onClick={() => AnalyticsEvent({
                  category: "NewsletterDownload",
                  action: "Click",
                  source: "/",
                  label: "homepageNewsletterButton-q3-2025"
                })}
              >
                <i className="fa fa-file-pdf-o"></i> Download
              </a>
            </p>
        </div>
      </div>
      <div className="col-lg-6 order-lg-first">
        <div className="img-gallery">
        <a href="/docs/newsletter/EduZTuition-Q3-2025-Newsletter.pdf"
            target="_blank"
            rel="noreferrer"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="200"
            onClick={() => AnalyticsEvent({
              category: "NewsletterDownload",
              action: "Click",
              source: "/",
              label: "homepageNewsletterImage-q3-2025"
            })}
          >
            <img
              src="images/site/homepage/newsletter/q3-2025-newsletter-1.webp"
              alt="media"
              data-aos="fade-right"
              data-aos-duration="1200"
              style={{border: "2px black solid"}}
            />
          </a>
          <img
            src="images/shape/49.svg"
            alt="shape"
            className="shapes shape-one"
          />
          <img
            src="images/shape/54.svg"
            alt="shape"
            className="shapes shape-three"
          />
        </div>
        {/* /.img-gallery */}
      </div>
    </div>
  );
};

export default Newsletter;
